import {Path} from 'slate'

export const pathEquals = (path: Path, another: Path): boolean => {
  return path.length === another.length && path.every((n, i) => n === another[i])
}
